import { autoinject } from "aurelia-framework";
import { BaseRangeRuleEditor } from "./base-range-rule-editor";
import { PressureConverter } from "../../../converters/pressure-value";
import { Api } from "../../../services/api";
import { MdToastService } from "aurelia-materialize-bridge";
import { I18N } from "aurelia-i18n";
import { MeasurementSystems } from "../../../converters/measurement-systems";

@autoinject
export class PipePressureRuleEditor extends BaseRangeRuleEditor {

	pressureUnits: string;

	constructor(api: Api, toastService: MdToastService, i18n: I18N) {
		super(api, toastService, i18n);
		this.pressureUnits = this.getUnits();
	}

	activate(model: any) {
		this.treeNode = model.selectedNode;
		this.property = model.property;

		const data = model.property.value.split(",");

		if (data.length === 4) {
			this.recommendedMinimum = this.convertPressure(data[0]);
			this.requiredMinimum = this.convertPressure(data[1]);
			this.requiredMaximum = this.convertPressure(data[2]);
			this.recommendedMaximum = this.convertPressure(data[3]);
		}

		if (data.length === 2) {
			this.requiredMinimum = this.convertPressure(data[0]);
			this.requiredMaximum = this.convertPressure(data[1]);
		}
	}

	getMeasurementSystem() {
		let system = localStorage.getItem("measurement-system");
		if (!system) {
			system = MeasurementSystems.imperial;
		}
		return system;
	}

	getUnits(): string {
		let system = this.getMeasurementSystem();
		switch (system) {
		case MeasurementSystems.imperial:
			return "psi";
		case MeasurementSystems.metric:
			return "kPa";
		default:
			return "psi";
		}
	}

	convertPressure(pressure: number) {
		let system = this.getMeasurementSystem();
		switch (system) {
		case MeasurementSystems.metric:
			return pressure;
		case MeasurementSystems.imperial:
				return this.round(PressureConverter.toImperial(pressure), 1);
		default:
				return this.round(PressureConverter.toImperial(pressure), 1);
		}
	}

	convertPressureBack(pressure: number) {
		let system = this.getMeasurementSystem();
		switch (system) {
		case MeasurementSystems.metric:
				return pressure;
		case MeasurementSystems.imperial:
			return PressureConverter.toMetric(pressure);
		default:
			return PressureConverter.toMetric(pressure);
		}
	}

	round(value: number, precision: number): number {
		const multiplier = Math.pow(10, precision || 0);
		return Math.round(value * multiplier) / multiplier;
	}

	async applyChanges() {
		const data = `${this.convertPressureBack(this.recommendedMinimum)},${this.convertPressureBack(this.requiredMinimum)},${this.convertPressureBack(this.requiredMaximum)},${this.convertPressureBack(this.recommendedMaximum)}`;
		const result = await this.addOrUpdateProperty(data);
	}

	async delete() {
		const result = await super.deleteProperty(this.property);
	}
}
